import type { Ref } from 'vue'
import { reactive, ref, unref } from 'vue'

export const emptyDragImage = new Image()
emptyDragImage.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'

export function useDraggable(items: unknown[] | Ref<unknown[]>) {
  const list = unref(items)

  const draggingIndex = ref(-1)

  function dragstart(index: number, event: DragEvent) {
    draggingIndex.value = index
    event.dataTransfer?.setDragImage(emptyDragImage, 0, 0)
  }

  function dragover(index: number, event: DragEvent) {
    if (event.clientY < 150) {
      window.scrollTo({
        top: window.scrollY - 1,
        behavior: 'instant',
      })
    }

    if (index === draggingIndex.value) {
      return
    }

    list.splice(draggingIndex.value, 0, list.splice(index, 1)[0])
    draggingIndex.value = index
  }

  function dragend() {
    draggingIndex.value = -1
  }

  return reactive({
    draggingIndex,
    dragstart,
    dragover,
    dragend,
  })
}
